<template>
<div>


    <div v-if=showgraph>
        <plotconnects :key=myKey chartId="connects" class="chart-wrapper" style="height:120px;margin-bottom:10px;" :serial=this.serial :device=device :period=period :deviceID="this.deviceID"></plotconnects>
    </div>
    <!-- <div v-if=showtable>
        <tabulateconnects :key=myKey chartId="connects" class="chart-wrapper" style="margin-top:10px;"  :serial=this.serial :device=device :period=period :deviceID="this.deviceID"></tabulateconnects>
    </div> -->

        <!-- <b-button type="button" :pressed.sync="showtable" variant="outline-primary" class="float-right"><i class="icon-grid"></i></b-button> -->
    <!-- <b-button type="button" :pressed.sync="showgraph" variant="outline-primary" class="float-right"><i class="icon-graph"></i></b-button> -->
    <b-button-toolbar class="float-right" aria-label="Toolbar with buttons group">
        <b-form-radio-group class="mr-3" id="period" buttons button-variant="outline-secondary" v-model="period" name="period" @input="reload">
            <b-form-radio class="mx-0" value="D">D</b-form-radio>
            <b-form-radio class="mx-0" value="W">W</b-form-radio>
            <b-form-radio class="mx-0" value="M">M</b-form-radio>
            <b-form-radio class="mx-0" value="Y">Y</b-form-radio>
        </b-form-radio-group>
    </b-button-toolbar>

</div>
</template>

<script>
import PlotConnects from '../graphs/PlotConnects'
// import TabulateConnects from '../graphs/TabulateConnects'

export default {
    components: {
        'plotconnects': PlotConnects,
        // 'tabulateconnects': TabulateConnects,
    },
    props: {
        serial: '',
        deviceID: '',
        device: {
            type: String,
            default: ''
        },
    },
    data() {
        return {
            period: 'W',
            myKey: 0,
            showgraph: true,
            showtable: false,

        }
    },
    methods: {
        reload() {
            this.myKey += 1;
        },
    },

}
</script>
